import { z } from 'zod';
import { maintenanceSha256Schema, maintenanceUtcTimestampSchema } from './maintenanceSchemas';

/** Release-pipeline authority, separate from maintenance commands and dashboard content. */
export const PLATFORM_INSTALLER_RELEASE_DOMAIN = 'playcast-platform-installer-release:v1\n';
export const PLATFORM_INSTALLER_CATALOG_PREFIX = 'maintenance/v1';
export const MAX_PLATFORM_INSTALLER_BYTES = 4 * 1024 * 1024 * 1024;
export const platformInstallerBranchSchema = z.string().regex(/^[a-z0-9][a-z0-9-]{0,127}$/);
export const platformInstallerReleaseSchema = z.object({
  schemaVersion: z.literal(1),
  purpose: z.literal('platform-installer'),
  branch: platformInstallerBranchSchema,
  installerVersion: z.string().min(1).max(128),
  targetVersion: z.string().min(1).max(128),
  sha256: maintenanceSha256Schema,
  byteLength: z.number().int().positive().max(MAX_PLATFORM_INSTALLER_BYTES),
  publishedAtUtc: maintenanceUtcTimestampSchema,
}).strict();
export type PlatformInstallerRelease = z.infer<typeof platformInstallerReleaseSchema>;

export function platformInstallerObjectKey(sha256: string): string {
  return `${PLATFORM_INSTALLER_CATALOG_PREFIX}/installers/${maintenanceSha256Schema.parse(sha256)}.exe`;
}
export function platformInstallerReleaseKey(digest: string): string {
  return `${PLATFORM_INSTALLER_CATALOG_PREFIX}/releases/${maintenanceSha256Schema.parse(digest)}.json`;
}
export function platformInstallerChannelKey(branch: string): string {
  return `${PLATFORM_INSTALLER_CATALOG_PREFIX}/channels/${platformInstallerBranchSchema.parse(branch)}.json`;
}
